import React, {useEffect, useState} from "react";
import "./banner.scss";

const Banner = ({Desktop, Mobile}) => {
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    // Function to update the background image based on screen size
    const updateBackgroundImage = () => {
      if (window.innerWidth <= 768) {
        // Mobile breakpoint
        setImageUrl(Mobile); // Mobile image URL
      } else {
        setImageUrl(Desktop); // Desktop image URL
      }
    };

    // Set initial background image
    updateBackgroundImage();

    // Add event listener for window resize
    window.addEventListener("resize", updateBackgroundImage);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateBackgroundImage);
    };
  }, []);

  return (
    <div
      className="background-container"
      style={{
        backgroundImage: `url(${imageUrl})`,
      }}></div>
  );
};

export default Banner;
